import {
  CButton,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow
} from '@coreui/react';
import React, {useContext, useState} from 'react';
import styles from './Table.module.css';
import TableCaption from './TableCaption';
import TableFooter from './TableFooter';
import { AppContext } from '../../context/AppContext';
import { ErrorHandler } from '../../utils/ErrorHandler';
import axios from 'axios';
import {API_URL} from '../../constants/index.js';
import CIcon from '@coreui/icons-react';
import { cilChevronBottom, cilChevronCircleDownAlt, cilExternalLink } from '@coreui/icons';
import { Link } from 'react-router-dom';


const Table = ({ columns, data, pagination }) => {

  const {setPetsPageUrl} = useContext(AppContext);

  const [showDropdown, setShowDropdown] = useState(false);

  const handleAction = (id, userId, type, name) => {
    const idToString = id.toString();
    const petId = idToString.slice(0, idToString.length - 2);
    function downloadURI(uri, name) {
      var link = document.createElement("a");
      link.download = name;
      link.href = uri;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    if( type == 'ruf'){
      axios
        .get(`${API_URL}admin/badge-requests/${type}/${petId}/${userId}`, {responseType:"blob"})
        .then((res) => {
          let reader = new window.FileReader();
          reader.readAsDataURL(res.data); 
          reader.onload = function() {
          let imageDataUrl = reader.result;
          downloadURI(imageDataUrl, `Findpet - ${id} - ${type.toUpperCase()} - ${name}.png`);
        }})
        .catch((err) => ErrorHandler(err));
    }else{
      axios
      .get(`${API_URL}admin/pets/${petId}/${type}`, {responseType:"blob"})
      .then((res) => {
        let reader = new window.FileReader();
        reader.readAsDataURL(res.data); 
        reader.onload = function() {
        let imageDataUrl = reader.result;
        downloadURI(imageDataUrl, `Findpet - ${id} - ${type.toUpperCase()} - ${name}`);
      }})
      .catch((err) => ErrorHandler(err));
    }
  }

  return (
    <>
      {/* <CCol className="mt-4 mb-5">
        <CFormInput
          type="search"
          placeholder="Buscar por nombre de mascota"
          style={{ width: '100%' }}
        />
      </CCol>
      <CCol className="mt-4 mb-5">
        <CFormInput
          type="search"
          placeholder="Buscar por N de RUF"
          style={{ width: '100%' }}
        />
      </CCol> */}
      {data.length !== 0 ?
        <>
          <div className="col-12">
          <TableCaption pagination={pagination} noun="mascotas" />
          <div className={styles.tableCard}>
          <CTable responsive style={{width:"100%"}} className={styles.styledTable}>
            <CTableHead>
              <CTableRow>
                {columns.map((col, index) => (
                  <CTableHeaderCell key={index} scope="col" style={{textAlign:col.alignEnd ? "end" : "start", width:(col.key === "name" || col.key === "breed" || col.key === "specie") ? "16%" : "auto" }}>
                    {col.label}
                  </CTableHeaderCell>
                ))}
              </CTableRow>
            </CTableHead>
            <CTableBody>
                {data.map((el, index) => (
                  <CTableRow key={index}>
                    <CTableDataCell>{el.id}</CTableDataCell>
                    <CTableDataCell>
                      <Link
                        to={`/dashboard/pets/${el.id}`}
                        target="_blank"
                        title="Ver mascota"
                        className={styles.petLink}
                      >
                        {el.name} <CIcon icon={cilExternalLink} size="sm" />
                      </Link>
                    </CTableDataCell>
                    <CTableDataCell>{el.specie}</CTableDataCell>
                    <CTableDataCell>{el.breed}</CTableDataCell>
                    <CTableDataCell>{el.gender}</CTableDataCell>
                    <CTableDataCell>{el.pet_identification}</CTableDataCell>
                    <CTableDataCell>
                      <div className="d-flex flex-column align-items-end">
                      <div className="d-flex">
                        <CButton className={styles['downloadQr']} onClick={() => handleAction(
                            el.pet_identification, 
                            null, 
                            "qr",
                            el.name
                          )}
                        >
                          Descargar QR
                        </CButton>
                        <CButton className={styles['downloadRuf']} onClick={() => setShowDropdown({id: el.pet_identification, show:!showDropdown.show})}>
                          Descargar RUF 
                          <CIcon icon={cilChevronCircleDownAlt} style={{marginLeft:6}}/>
                        </CButton>
                      </div>
                      {(showDropdown.id == el.pet_identification && showDropdown.show) &&
                        <div className={styles.userPetDropdown}>
                          {el?.users?.map((user,i) => (
                            <p key={i} onClick={() => handleAction(
                                el.pet_identification, 
                                user.id, 
                                'ruf',
                                el.name
                              )}
                            >
                              {user.name}
                            </p>
                          ))}
                        </div>
                      }
                      </div>
                    </CTableDataCell>
                  </CTableRow>
                ))}
            </CTableBody>
          </CTable>
          </div>
          </div>
          <TableFooter range={pagination?.links} setPageUrl={setPetsPageUrl} />
        </> : 
        <div className="col-12">
          <div className={styles.tableCard}>
            <div className={styles.emptyState}>No se encontraron resultados.</div>
          </div>
        </div>
      }
    </>
  );
};

export default Table;
